let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d0X7J")).then(() => parcelRequire('ebIkR'));